<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter" style="background: white">
            <div
              class="vx-col hidden lg:block lg:w-1/2"
              style="background: antiquewhite"
            >
              <div class="vx-col hidden lg:block lg:w-1/2">
                <div class="p-8">
                  <div class="vx-card__title mb-8">
                    <h3 class="mb-4" style="color: #de1ea3; font-weight: 600">
                      Contact Us
                    </h3>
                  </div>
                  <div class="flex flex-wrap float-center my-10">
                    <a
                      href="mailto:support@smartwaveindia.com"
                      style="
                        text-decoration-line: none;
                        display: flex;
                        margin: 5px;
                      "
                    >
                      <feather-icon
                        icon="MailIcon"
                        class="custom-class"
                        title="close"
                        style="color: #de1066b3"
                      ></feather-icon>
                      <h6
                        style="
                          font-size: 13px;
                          margin-left: 10px;
                          color: #5d5656;
                        "
                      >
                        support@smartwaveindia.com
                      </h6>
                    </a>
                    <a href="" style="display: flex; margin: 5px">
                      <feather-icon
                        icon="PhoneIcon"
                        class="custom-class"
                        title="close"
                        style="color: #008000bf"
                      ></feather-icon>
                      <h6
                        style="
                          font-size: 13px;
                          margin-left: 10px;
                          color: #5d5656;
                        "
                      >
                        &nbsp;9633011603
                      </h6>
                    </a>
                    <a
                      href="https://www.youtube.com/watch?v=3UHZmppfZ4c"
                      target="_blank"
                      style="
                        text-decoration-line: none;
                        display: flex;
                        margin: 5px;
                      "
                    >
                      <feather-icon
                        icon="YoutubeIcon"
                        class="custom-class"
                        title="close"
                        style="color: #de0a0a"
                      ></feather-icon>
                      <h6
                        style="
                          font-size: 13px;
                          margin-left: 10px;
                          color: #5d5656;
                        "
                      >
                        &nbsp;Demo Video
                      </h6>
                    </a>
                    <a
                      href="http://smartwaveindia.com/"
                      target="_blank"
                      style="
                        text-decoration-line: none;
                        display: flex;
                        margin: 5px;
                      "
                    >
                      <feather-icon
                        icon="ChromeIcon"
                        class="custom-class"
                        title="close"
                        style="color: #3348abd1"
                      ></feather-icon>
                      <h6
                        style="
                          font-size: 13px;
                          margin-left: 10px;
                          color: #5d5656;
                        "
                      >
                        &nbsp;www.smartwaveindia.com
                      </h6>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h3 class="titleText mb-4">Smart Clinic</h3>
                  <p>Welcome back, please login to your account.</p>
                  <vs-alert
                    v-if="errorMessage"
                    icon="warning"
                    active="true"
                    color="warning"
                    class="my-5"
                  >
                    {{ errorMessage }}
                  </vs-alert>
                </div>
                <vs-input
                  name="username"
                  type="text"
                  icon="icon icon-user"
                  @keypress.enter="login"
                  icon-pack="feather"
                  label-placeholder="Username"
                  v-model="loginform.name"
                  class="w-full no-icon-border"
                />

                <vs-input
                  type="password"
                  name="password"
                  icon="icon icon-lock"
                  @keypress.enter="login"
                  icon-pack="feather"
                  label-placeholder="Password"
                  v-model="loginform.password"
                  class="w-full mt-6 no-icon-border"
                />

                <div
                  class="flex flex-wrap float-center my-5"
                  style="margin-left: 35%"
                >
                  <vs-button
                    id="button-with-loading"
                    class="float-center vs-con-loading__container"
                    @click="login"
                    >Login</vs-button
                  >
                </div>
                <div
                  class="flex flex-wrap float-center"
                  style="margin-left: 25%"
                >
                  <router-link
                    to="/register"
                    style="
                      color: rgb(115 103 240);
                      font-size: 12px;
                      font-weight: bold;
                    "
                    >New User? Create account</router-link
                  >
                </div>
                <div
                  class="flex flex-wrap float-center"
                  style="margin-left: 35%; margin-top: 5px"
                >
                  <router-link
                    to="/forgotPassword"
                    style="
                      color: rgb(115 103 240);
                      font-size: 11px;
                      font-weight: bold;
                    "
                    >Forgot password?</router-link
                  >
                </div>
                <div
                  class="flex flex-wrap float-center my-2"
                  style="margin-left: 28%"
                >
                  <a
                    href="http://www.smartwaveindia.com/"
                    style="color: #9fa7af"
                    >SmartWave Solutions</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginform: {
        name: "",
        password: "",
      },
      errorMessage: "",
    };
  },

  methods: {
    openLoading() {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#button-with-loading",
        scale: 0.45,
      });
    },
    login() {
      this.openLoading();
      this.$http
        .post("authenticate", JSON.stringify(this.loginform), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const data = response.data.data;

          this.$session.start();
          this.$session.set("userId", data.userId);
          this.$session.set("userName", data.userName);
          this.$session.set("userCategoryId", data.userCategoryId);
          this.$session.set("companyId", data.companyId);
          this.$session.set("companyName", data.companyName);
          this.$session.set("userToken", data.userToken);
          this.$session.set("role", "Clinic");
          //localStorage.setItem("userModules", JSON.stringify(response.data.data.modules));
          // this.$store.dispatch("setUserModules", response.data.data.modules)
          console.log("STEP 4: USER SET");

          console.log("STEP 5: BEFORE localStorage");
          console.log("MODULES TYPE:", typeof data.modules);
          console.log("MODULES VALUE:", data.modules);

          localStorage.setItem("userModules", JSON.stringify(data.modules));

          this.$store.dispatch("setUserModules", data.modules);

          this.$router.push("/Overview");
        })
        .catch((error) => {
          this.errorMessage = "Invalid Login";
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        });
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}

.titleText {
  color: #7367f0;
  font-weight: 600;
 
}
</style>
